import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgModel = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5 12.25V13.2147C10.5 13.9216 9.92143 14.5 9.21429 14.5H2.78571C2.07857 14.5 1.5 13.9216 1.5 13.2147V6.78847C1.5 6.08158 2.07857 5.50322 2.78571 5.50322H3.75M6.78571 10.5H13.2143C13.9244 10.5 14.5 9.92437 14.5 9.21429V2.78571C14.5 2.07563 13.9244 1.5 13.2143 1.5H6.78571C6.07563 1.5 5.5 2.07563 5.5 2.78571V9.21429C5.5 9.92437 6.07563 10.5 6.78571 10.5Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgModel;
